import { useFrame } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import type { Group } from 'three';
import { useGameStore } from '../../simulation/store';
import { coordToWorld } from '../../utils/grid';

export function AmbientLife() {
  const groupRef = useRef<Group>(null);
  const cells = useGameStore((state) => state.world.cells);
  const size = useGameStore((state) => state.world.size);
  const treeCells = useMemo(
    () => cells.filter((cell) => !cell.road && !cell.buildingId && cell.treeSeed > 0.87).slice(0, 120),
    [cells]
  );
  const flowers = useMemo(
    () => cells.filter((cell) => !cell.road && !cell.buildingId && cell.flowerSeed > 0.92).slice(0, 90),
    [cells]
  );

  useFrame(({ clock }) => {
    if (groupRef.current) {
      groupRef.current.rotation.y = Math.sin(clock.elapsedTime * 0.2) * 0.01;
    }
  });

  return (
    <group ref={groupRef}>
      {treeCells.map((cell) => {
        const position = coordToWorld(cell.coord, size);
        return (
          <group key={`tree-${cell.key}`} position={[position.x + 0.18, 0.08, position.z - 0.18]}>
            <mesh castShadow position={[0, 0.16, 0]}>
              <cylinderGeometry args={[0.04, 0.055, 0.28, 6]} />
              <meshStandardMaterial color="#76543a" />
            </mesh>
            <mesh castShadow position={[0, 0.4, 0]}>
              <icosahedronGeometry args={[0.22, 0]} />
              <meshStandardMaterial color={cell.treeSeed > 0.94 ? '#5f9866' : '#6f9a52'} roughness={0.9} />
            </mesh>
          </group>
        );
      })}
      {flowers.map((cell) => {
        const position = coordToWorld(cell.coord, size);
        return (
          <mesh key={`flower-${cell.key}`} position={[position.x - 0.24, 0.08, position.z + 0.2]}>
            <sphereGeometry args={[0.035, 6, 6]} />
            <meshStandardMaterial color={cell.flowerSeed > 0.96 ? '#d26b49' : '#e6a83f'} />
          </mesh>
        );
      })}
      <group position={[0, 8.5, 0]}>
        {Array.from({ length: 8 }, (_, index) => (
          <mesh key={`bird-${index}`} position={[-8 + index * 2.1, Math.sin(index) * 0.3, -5 + Math.cos(index) * 2]} rotation={[0, index * 0.4, 0]}>
            <coneGeometry args={[0.08, 0.26, 3]} />
            <meshBasicMaterial color="#1f2a2e" transparent opacity={0.55} />
          </mesh>
        ))}
      </group>
    </group>
  );
}
